document.addEventListener('DOMContentLoaded', () => {
    // Step 1: Parse product JSON
    const productJsonElement = document.querySelector('#price-per-item');
    if (!productJsonElement) return;
    const productJson = JSON.parse(productJsonElement.getAttribute('data-product_json'));
    if (!productJson || !productJson.variants) return;
  
    // Debug: check parsed JSON
    console.log('Product JSON loaded:', productJson);
  
    // Step 2: Function to update price per item
    function updatePricePerItem() {
      const selectedRadio = document.querySelector('input[name="Quantity-2"]:checked');
      if (!selectedRadio) return;
  
      const radioValue = selectedRadio.value;
      // Extract pack number from radio button, e.g., "Pack of 25" → 25
      const match = radioValue.match(/\d+/);
      if (!match) return;
  
      const packSize = parseInt(match[0], 10);
      console.log('Selected pack size:', packSize);
  
      // Step 3: Extract the selected color from the radio button's name or other related attributes
      // Example: We'll check if the color is part of the name or options for matching
      const selectedColorRadio = document.querySelector('input[name="Quantity-2"]:checked + label');
      const selectedColor = selectedColorRadio ? selectedColorRadio.innerText.toLowerCase() : '';
      console.log('Selected color:', selectedColor);
  
      // Step 4: Find the selected variant based on both color and pack size
      const selectedVariant = productJson.variants.find(variant => {
        const variantTitle = variant.title.toLowerCase();
        // Check if the variant title contains both color and pack size
        return variantTitle.includes(selectedColor) && variantTitle.includes(`pack of ${packSize}`);
      });
  
      console.log('Matched variant:', selectedVariant);
  
      // Step 5: If a valid variant is selected, calculate the price per item
      const priceElement = document.getElementById('per-item-price');
      if (selectedVariant && priceElement) {
        const totalPrice = selectedVariant.price / 100; // Shopify prices are in cents
        const pricePerItem = (totalPrice / packSize).toFixed(2);
        priceElement.innerText = pricePerItem;
      } else if (priceElement) {
        priceElement.innerText = 'N/A';
      }
    }
  
    // Step 6: Attach event listeners to all quantity radio buttons
    const radios = document.querySelectorAll('input[name="Quantity-2"]');
    radios.forEach(radio => {
      radio.addEventListener('change', updatePricePerItem);
    });
  
    // Step 7: Initialize price per item on page load
    updatePricePerItem();
  });
  
  (function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      // Check if the link is not to the same hostname
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
  
      // Check if the link is a PDF
      if (links[i].href.toLowerCase().endsWith('.pdf')) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  })();
  
////////////////////////////////////////////////////////////////////////
